// Shared by the enroll + event-claim success screens: which wallet badge to
// show, and the matching `wallet` hint on the /save link so the server serves
// the same wallet the badge promised (see apps/api/src/lib/wallet-ua.ts).

/** Any iPhone/iPad/iPod, in any browser. iPadOS 13+ reports as "Macintosh"
 *  (desktop UA), so the /iPad/ test misses it — detect the touch-capable Mac
 *  as an iPad. (navigator.platform is deprecated but still the most reliable
 *  signal for this specific case.) */
export function isAppleDevice(): boolean {
  const isIPadOS =
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  return /iP(hone|od|ad)/.test(navigator.userAgent) || isIPadOS
}

/** Offer Apple only on an Apple device AND when the API advertises it (flag
 *  on), so non-iOS or flag-off users keep the Google badge. */
export function shouldUseApple(providersAvailable: string[] | undefined): boolean {
  return isAppleDevice() && (providersAvailable?.includes('apple') ?? false)
}

export function saveLinkFor(saveUrl: string, useApple: boolean): string
export function saveLinkFor(
  saveUrl: string | undefined,
  useApple: boolean,
): string | undefined
export function saveLinkFor(
  saveUrl: string | undefined,
  useApple: boolean,
): string | undefined {
  if (!saveUrl) return saveUrl
  return `${saveUrl}${saveUrl.includes('?') ? '&' : '?'}wallet=${useApple ? 'apple' : 'google'}`
}
